<template>
  <div class="envelope-image" :data-spin="spin">
    <EnvelopeSVG ref="svg" />
  </div>
</template>

<script>
import EnvelopeSVG from "@/assets/envelope.svg"

export default {
  name: "EnvelopeImage",
  components: {
    EnvelopeSVG
  },
  data() {
    return {
      spin: false,
      observer: null,
    }
  },
  mounted: function() {
    if ("IntersectionObserver" in window) {
      const svg = this.$refs.svg
      const flap = svg.getElementById("flap")

      const animateFlaps = () => {
        const top = svg.getBoundingClientRect().top

        let elScrollPerc = (1 - top / (svg.clientHeight)) * 2.5

        if (elScrollPerc > 1) {
          elScrollPerc = 1
        } else if (elScrollPerc < 0) {
          elScrollPerc = 0
        }

        let flapPos = 587.3 * elScrollPerc

        // Browsers change the original `<polygon>` element into a `<path>`, hence using
        // `d` attribute here, rather than `points`.
        flap.setAttribute("d", "M587.29 293.65L293.65 " + flapPos +" 0 293.65h587.29z")
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          // Scroll listener is expensive, so be agressive with the cleanup
          removeEventListener("scroll", animateFlaps, true)
          if (entries[0].isIntersecting) {
            addEventListener("scroll", animateFlaps, true)
          }
        },
        {threshold: 0.5}
      );

      animateFlaps()
      this.observer.observe(this.$el)
    }

  },
  methods: {
    startSpin() {
      this.spin = true
    },
    stopSpin() {
      this.spin = false
    },
  }
}
</script>

<style lang="scss" scoped>
  .envelope-image {
    position: relative;

    svg {
      transform-origin: center;
      transition: none;
    }

    &[data-spin="true"] {
      &:before {
        content: " ";
        display: none;
        position: absolute;
        top: 50%;
        left: 50%;
        background: red;
        border-radius: 50%;
        height: 30px;
        width: 30px;
        animation: shoot 1s;
      }

      svg {
        // animation: shake 1s;
        animation: spin 1.5s forwards;
      }
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg) scale(1);
    }
    50%, 100% {
      transform: rotate(720deg) scale(0);
    }
  }

  @keyframes shake {
    0% {
      transform: scaleY(1), rotate(0deg);
    }
    55% {
      transform: scaleY(0.6), rotate(20deg);
    }
    70% {
      transform: scaleY(0.4), scaleX(0.6) rotate(-20deg);
    }
    80% {
      transform: scaleY(1), rotate(20deg);
    }
  }

  @keyframes shoot {
    0% {
      top: 50%;
      left: 50%;
    }
    100% {
      top: 100%;
      left: 100%;
    }
  }
</style>
